import PoliticalPartyInfo from "../PoliticalPartyInfo";

export default function () {
	return (
		<>
			<div className="card">
				<PoliticalPartyInfo header={"Political Party"} />
			</div>
		</>
	);
}
